export const describedBy = (
  ...ids: Array<string | false | undefined>
): string | undefined => ids.filter(Boolean).join(" ") || undefined;
